import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex-node-col align-center centered padh2"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 1,
  class: "no-picture flex-container-row align-center centered"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      ref: "pictureHolder",
      class: _normalizeClass(["text-center full-size", _ctx.$attrs.class])
    }, [
      (_ctx.hasPicture)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _withDirectives(_createVNode(_component_loader, { size: "75%" }, null, 512), [
              [_vShow, !_ctx.pictureData.pictureHasLoaded]
            ]),
            _withDirectives(_createElementVNode("img", {
              src: _ctx.pictureData.pictureData,
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openZoom && _ctx.openZoom(...args))),
              class: _normalizeClass(["max100p", [ 'material-image',
                              _ctx.withZoom ? 'material-image-zoom hover-lift' : null,
                              _ctx.withBorder ? 'with-border' : null
                            ]]),
              style: _normalizeStyle(_ctx.maxHeight ? `max-height: ${ _ctx.maxHeight }px` : '')
            }, null, 14, _hoisted_2), [
              [_vShow, _ctx.pictureData.pictureHasLoaded]
            ]),
            (_ctx.withZoom && _ctx.showHints)
              ? _withDirectives((_openBlock(), _createElementBlock("div", {
                  key: 0,
                  style: {"font-size":"small"}
                }, _toDisplayString(_ctx.localize('clickForZoom')), 513)), [
                  [_vShow, _ctx.pictureData.pictureHasLoaded]
                ])
              : _createCommentVNode("", true)
          ]))
        : (_ctx.showHints)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", null, " [ " + _toDisplayString(_ctx.localize('noPicture')) + " ] ", 1)
            ]))
          : _createCommentVNode("", true)
    ], 2),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.zoomIsActive)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              ref: "zoomPane",
              class: "zoomPane",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeZoom && _ctx.closeZoom(...args)))
            }, [
              _createElementVNode("div", {
                ref: "zoomPictureHolder",
                class: "zoomPictureHolder",
                style: _normalizeStyle(_ctx.imageAsBackground())
              }, null, 4)
            ], 512))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}